module.exports = __webpack_public_path__ + "static/img/message.341836.svg";